import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditSectionLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'AddNewSection' */ './components/EditSection')
);

export default (store) => {
	return {
		path: 'section-setup/:campusId?/edit-section/:sectionId',
		element: <AsyncLoading component={<EditSectionLazy />} />,
	};
};
